// Auth Data

export default {
  email: {
    label: 'Email',
    placeholder: 'Укажите email',
    value: '',
    type: 'email',
    error: null,
    min: 3,
    max: 100,
    req: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    validate: true
  },
  password: {
    label: 'Пароль',
    placeholder: 'Укажите пароль',
    value: '',
    type: 'password',
    error: null,
    min: 6,
    max: 100,
    req: null,
    validate: true
  }
}
